<template>
	<div>
		<div class="no-print" v-if="!disabled">
			<div class="row form-group">
				<div class="col-xs-12">
					<div style="display: flex" :class="{coluna: botaoGrande}">
						<div
							v-if="button == true"
							class="input-group input-group-sm"
							:class="{'text-center': !botaoGrande}"
							style="margin-top: 3px"
						>
							<span class="input-group-btn" style="">
								<label
									:for="($attrs.name ? $attrs.name : 'anexo_') + idInput"
									class="btn btn-default"
									style="cursor: pointer"
									:class="{botaoGrande: botaoGrande}"
								>
									<i class="fa fa-paperclip fa-fw" style="font-size: 14px"></i>
									{{ _traducao('global', 'cliqueParaAnexar').toUpperCase() }}
								</label>
							</span>
						</div>
						<input
							type="file"
							style="display: none"
							:name="$attrs.name ? $attrs.name + '[]' : 'arquivo[]'"
							:accept="extensoesInput"
							:id="($attrs.name ? $attrs.name : 'anexo_') + idInput"
							@change="upload"
							ref="file"
						/>

						<div
							class="text-info no-print"
							style="margin-left: 10px"
							v-if="labelArquivosPermitidos && legend"
						>
							<small>
								<i class="fa fa-info-circle"></i>
								{{ _traducao('uploadfile', 'extPermitidas') }}
							</small>
							<br />
							<label class="label label-info">{{ arquivosPermitidos }}</label>
							<br />
							<small class="u__xs-text"> (Max 10MB) </small>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-3">
					<div class="text-danger" v-if="erroMSG">
						<span v-html="erroMSG"></span>
					</div>
				</div>
			</div>
		</div>

		<div v-show="enviando">
			<label>{{ _traducao('global', 'enviando') }}...</label>
			<div class="progress enviando">
				<div
					class="progress-bar progress-bar-success progress-bar-striped active"
					role="progressbar"
					aria-valuenow="100"
					aria-valuemin="0"
					aria-valuemax="100"
					style="width: 100%; padding-top: 2px"
				>
					<!-- <i class="fa fa-fw fa-refresh fa-spin"></i>{{_traducao('global','enviando').toUpperCase()}}... -->
				</div>
			</div>
		</div>

		<div class="row" v-if="exibeListaCarregados">
			<div
				class="col-xs-12 col-sm-6 col-md-3 col-lg-4"
				v-for="(item, index) in files"
				:key="index.id"
			>
				<div class="lista">
					<div class="icones">
						<i :class="item.icone" style="margin-top: 4px"></i>
					</div>
					<div class="info-arquivo">
						<label
							>{{ item.nome }}<br /><small>{{
								item.hasOwnProperty('tamanho') &&
								item.tamanho != '' &&
								item.tamanho != 0
									? item.tamanho + 'KB'
									: ''
							}}</small></label
						>
					</div>
					<div class="info">
						<div class="remover">
							<a
								href="#"
								@click.prevent="remove(index)"
								title="Remover arquivo"
							>
								<i class="fa fa-trash-o"></i>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row">
			<div
				class="col-xs-12 col-sm-4 col-md-3 col-lg-3"
				v-for="(item, index) in listaArquivosCarregados"
				:key="index.id"
			>
				<div class="lista">
					<div class="icones">
						<i :class="item.icone" style="margin-top: 4px"></i>
					</div>
					<div class="info-arquivo">
						<label
							>{{ item.nome }}<br />
							<small>{{
								item.hasOwnProperty('tamanho') &&
								item.tamanho != '' &&
								item.tamanho != 0
									? item.tamanho + 'KB'
									: ''
							}}</small>
						</label>
					</div>
					<div class="info">
						<div v-if="validaExclusao" class="remover">
							<a
								href="#"
								@click.prevent="clickExcluirAnexo(item, index)"
								v-if="habilitaExcluir"
							>
								<i class="fa fa-trash-o"></i>
							</a>
						</div>
						<div v-else class="remover">
							<a
								href="#"
								@click.prevent="removeCarregados(item, index)"
								v-if="habilitaExcluir"
							>
								<i class="fa fa-trash-o"></i>
							</a>
						</div>
						<div class="download">
							<a :href="item.link" target="_blank" title="Fazer download">
								<i class="fa fa-download"></i>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.enviando {
	width: 180px;
	/* margin-top: 10px; */
	height: 5px;
}

.lista {
	display: flex;
	justify-content: space-between;
	border: 1px solid #888;
	background-color: #fff;
	margin-top: 5px;
	height: 60px;
	cursor: pointer;
}
.lista .icones {
	padding: 5px;
	/* border:1px solid #000 */
}
.lista .info-arquivo {
	margin: 5px 0;
	width: 100%;
	overflow-x: auto;
}
.lista .info {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: flex-end;
	box-sizing: content-box;
}

.lista .info .remover i {
	padding: 4px 6px;
	font-size: 14px;
	color: #e00;
}

.lista .info .download i {
	padding: 4px 5px;
	font-size: 14px;
	color: #2196f3;
}

.lista:hover {
	background: #f5f5f5;
}

.coluna {
	flex-direction: column;
}

.botaoGrande {
	width: 450px;
}
</style>

<script>
export default {
	props: {
		idInput: {
			type: [String, Number],
			default: '0',
			required: false
		},

		arquivosSalvos: {
			type: Array,
			default: function () {
				return []
			},
			required: false
		},

		disabled: {
			type: Boolean,
			required: false,
			default: false
		},

		ext: {
			type: String,
			required: true
		},

		titulo: {
			type: String,
			required: false,
			default: ''
		},

		button: {
			type: Boolean,
			default: true
		},

		legend: {
			type: Boolean,
			default: true
		},

		unico: {
			type: Boolean,
			required: false,
			default: false
		},
		urlExcluir: {
			type: String,
			default: null
		},

		url: {
			type: String,
			required: true
		},

		tamanho: {
			type: Number,
			default: 0
		},

		excluirAdicionados: {
			type: Boolean,
			default: false
		},

		excluirURL: {
			type: Boolean,
			default: false
		},

		labelArquivosPermitidos: {
			type: Boolean,
			default: true
		},

		habilitaExcluir: {
			type: Boolean,
			default: false,
			required: false
		},

		exibeListaCarregados: {
			type: Boolean,
			default: true,
			required: false
		},
		validaExclusao: {
			type: Boolean,
			default: true,
			required: false
		},
		excluirPorId: {
			type: Boolean,
			default: false,
			required: false
		},
		botaoGrande: {
			type: Boolean,
			default: false,
			required: false
		}
	},

	data() {
		return {
			traducao: {
				'tp': 'pt-br',

				'pt-br': {}
			},
			tituloform: '',
			files: [],
			filesCarregados: this.arquivosSalvos,
			enviando: false,
			erroMSG: '',
			arquivosPermitidos: '',
			listExt: [],
			nomeArquivo: '',
			listaIcones: [
				{extensao: '.png', icone: 'fa fa-file-image-o fa-fw fa-2x'},
				{extensao: '.jpg', icone: 'fa fa-file-image-o fa-fw fa-2x'},
				{extensao: '.jpeg', icone: 'fa fa-file-image-o fa-fw fa-2x'},
				{extensao: '.pdf', icone: 'fa fa-file-pdf-o fa-fw fa-2x'},
				{extensao: '.xlsx', icone: 'fa fa-file-excel-o fa-fw fa-2x'},
				{extensao: '.xls', icone: 'fa fa-file-excel-o fa-fw fa-2x'},
				{extensao: '.docx', icone: 'fa fa-file-word-o fa-fw fa-2x'},
				{extensao: '.doc', icone: 'fa fa-file-text-o fa-fw fa-2x'},
				{extensao: '.txt', icone: 'fa fa-file-text-o fa-fw fa-2x'},
				{extensao: '.m4a', icone: 'fa fa-file-mp4-o fa-fw fa-2x'},
				{extensao: '.mp4', icone: 'fa fa-file-mp4-o fa-fw fa-2x'},
				{extensao: '.pptx', icone: 'fa fa-file-powerpoint-o fa-fw fa-2x'},
				{extensao: '.ppt', icone: 'fa fa-file-powerpoint-o fa-fw fa-2x'},
			]
		}
	},

	mounted() {
		this.eventos()

		if (this.titulo.trim() != '') {
			this.tituloform = this.titulo
		} else {
			this.tituloform = this._traducao('uploadfile', 'tituloForm')
		}

		this.listExt = this.ext.split('|')
		this.arquivosPermitidos = ''

		var lg = this.listExt.length
		for (var i = 0; i < lg; i++) {
			if (this.arquivosPermitidos == '') {
				this.arquivosPermitidos = this.listExt[i]
			} else {
				this.arquivosPermitidos += ', ' + this.listExt[i]
			}
		}
	},

	computed: {
		listaArquivosCarregados() {
			return this.filesCarregados.map((o) => {
				let icon = _.find(this.listaIcones, (i) => {
					return i.extensao == o.extensao
				})
				o.icone = _.isNil(icon) ? 'fa fa-file-o fa-fw fa-2x' : icon.icone
				return o
			})
		},
		extensoesInput() {
			return this.ext
				.split('|')
				.map((extension) => `.${extension}`)
				.join(',')
		}
	},

	methods: {
		clickExcluirAnexo(item, index) {
			this._modalExcluir(
				(retorno) => {
					if (retorno.excluir) {
						this.removeCarregadosAnexo(item, index)
					}
				},
				item,
				`<h3>Deseja excluir o anexo do sistema PERMANENTEMENTE?</h3>`,
				this._traducao('global', 'excluir').toUpperCase()
			)
		},

		eventos() {
			var self = this
			window.bus.$on('upload-file-carrega-lista', function (lista) {
				self.filesCarregados = lista
			})

			window.bus.$on('upload-file-limpa', function (name) {
				if (name == self.name) {
					self.filesCarregados = []
					self.files = []
				}
			})

			window.bus.$on('limpa-lista-arquivos', function () {
				self.files = []
				self.erroMSG = ''
			})
		},

		carregaLista(lista) {
			this.filesCarregados = lista
		},

		limpa() {
			this.filesCarregados = []
			this.files = []
		},

		limpaArquivos() {
			this.files = []
			this.erroMSG = ''
		},

		// REMOVE ANEXO CARREGADO, NÃO SALVOS
		remove(index) {
			this.files.splice(index, 1)
			if (this.excluirAdicionados) {
				this.$emit('upload-file', _.concat(this.files, this.filesCarregados))
			} else {
				this.$emit('upload-file', this.files)
			}
			this.erroMSG = ''
		},

		// REQUISIÇÃO PARA EXCLUIR ARQUIVOS JÁ SALVOS
		removeItemURL(item, index) {
			let cliente = $cliente.get('nome_pasta')

			if (cliente != 'ibama' && cliente != 'vale') {
				cliente = 'mg-siga'
			}
			if (this.urlExcluir != null) {
				window.bus.$emit('load-in', {text: 'Excluindo anexo'})
				this._httpGet(`${this.urlExcluir}/${item.id}`, (retorno) => {
					window.bus.$emit('load-out')
					if (retorno._request) {
						this.removeItemLista(index)
					} else {
						window.bus.$emit('exibir-notificacao', {
							text: 'Não foi possivel Excluir anexo',
							type: 'danger'
						})
					}
				})
			} else {
				if (item.id_solicitacao) {
					this._httpGet(
						`${cliente}/Solicitacao/excluir_anexo/` +
							item.id +
							'/' +
							item.nome_arquivo,
						(response) => {
							if (response._request) {
								this.removeItemLista(index)
							} else {
								window.bus.$emit('exibir-notificacao', {
									text: 'Não foi possível Excluir este documento',
									type: 'danger'
								})
							}
						}
					)
				}

				if (item.id_ordem_missao) {
					this._httpGet(
						`${cliente}/Ordem_missao/excluir_anexo/` +
							item.id +
							'/' +
							item.nome_arquivo,
						(response) => {
							if (response._request) {
								this.removeItemLista(index)
							} else {
								window.bus.$emit('exibir-notificacao', {
									text: 'Não foi possível Excluir este documento',
									type: 'danger'
								})
							}
						}
					)
				}
			}
		},

		removeItemURLAnexo(item, index) {
			let cliente = $cliente.get('nome_pasta')

			if (cliente != 'ibama' && cliente != 'vale') {
				cliente = 'mg-siga'
			}
			if (this.urlExcluir != null) {
				window.bus.$emit('load-in', {text: 'Excluindo anexo'})
				this._axios(`${this.urlExcluir}/${item.nome}`, 'get', {
					callback: (retorno) => {
						if (retorno._request) {
							this.removeItemLista(index)
							window.bus.$emit('excluir-anexo-documento')
						} else {
							window.bus.$emit('exibir-notificacao', {
								text: 'Não foi possivel Excluir anexo',
								type: 'danger'
							})
						}
					},
					finally: () => {
						window.bus.$emit('load-out')
					}
				})
			}
		},

		removeItemLista(index) {
			this.filesCarregados.splice(index, 1)

			this.$emit('upload-file', _.concat(this.files, this.filesCarregados))

			window.bus.$emit('exibir-notificacao', {
				text: 'Documento Excluído com Sucesso!',
				type: 'success'
			})

			this.erroMSG = ''
		},

		removeCarregados(item, index) {
			if (this.excluirURL) {
				this.removeItemURL(item, index)
			} else {
				this.removeItemLista(index)
			}
			// this.filesCarregados.splice(index, 1)
			// this.$emit('upload-file', _.concat(this.files, this.filesCarregados))
			// this.erroMSG = ""
		},

		removeCarregadosAnexo(item, index) {
			if (this.excluirURL) {
				if (this.excluirPorId) {
					this.removeItemURL(item, index)
				} else {
					this.removeItemURLAnexo(item, index)
				}
			} else {
				this.removeItemLista(index)
			}
		},

		validaUpload(nomeArquivo) {
			var nome = nomeArquivo.split('.')

			var passou = false
			var lg = this.listExt.length
			for (var i = 0; i < lg; i++) {
				if (
					this.listExt[i].toUpperCase() == nome[nome.length - 1].toUpperCase()
				) {
					passou = true
					break
				}
			}

			return passou
		},

		upload(e) {
			if (typeof e.target.files[0] !== 'undefined') {
				// se passar na validacao envia para o ws
				if (this.validaUpload(e.target.files[0].name)) {
					this.nomeArquivo = e.target.files[0].name
					var upload = {
						nome: e.target.files[0].name
					}

					// for single file
					var data = new FormData()
					data.append('arquivo', e.target.files[0])

					this.enviando = true
					this.$emit('enviando')
					this.erroMSG = ''

					jQuery.ajax({
						cache: false,
						contentType: false,
						processData: false,
						type: 'POST',
						headers: {Authorization: this.getToken()},
						data: data,
						url: this.url,
						dataType: 'json',
						success: (retorno) => {
							this.enviando = false
							this.$emit('enviado')

							if (retorno.status == 'sucesso') {
								upload.nomeTemp = retorno.url_img
								upload.ext = retorno.extensao
								upload.tamanho = retorno.tamanho

								let icone = _.find(this.listaIcones, (o) => {
									return o.extensao == retorno.extensao
								})

								upload.icone = _.isNil(icone)
									? 'fa fa-file-o fa-fw fa-2x'
									: icone.icone

								// limpa o obj atual
								if (this.unico == true) {
									this.limpa()
								}

								this.files.push(upload)
								this.nomeArquivo = ''
								if (this.excluirAdicionados) {
									this.$emit(
										'upload-file',
										this.files.concat(this.filesCarregados)
									)
								} else {
									this.$emit('upload-file', this.files)
								}

								$(this.$refs.file).val('')
							} else {
								window.bus.$emit('exibir-notificacao', {
									type: 'danger',
									text: retorno.mensagem
								})

								this.erroMSG = retorno.mensagem
							}
						},
						error: (e) => {
							window.bus.$emit('modal-erro-show', e)
						}
					})
				} else {
					this.erroMSG = this._traducao('uploadfile', 'erroMSG')
				}
			}
		}
	}
}
</script>